import axios from 'axios';

let currentVersion = null;
let checkInterval = null;

/**
 * Initialize version checking
 * Checks for new app version every 5 minutes
 */
export function initVersionCheck() {
    // Get initial version
    getCurrentVersion().then(version => {
        currentVersion = version;
        console.log('Current app version:', currentVersion);
    });

    // Check every 5 minutes
    checkInterval = setInterval(checkForUpdate, 5 * 60 * 1000);

    // Also check when tab becomes visible
    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
            checkForUpdate();
        }
    });
}

/**
 * Get current version from version.json
 */
async function getCurrentVersion() {
    try {
        const response = await axios.get('/version.json', {
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache'
            },
            // Add timestamp to prevent caching
            params: { t: Date.now() }
        });
        return response.data.version;
    } catch (error) {
        console.warn('Could not fetch version:', error);
        return null;
    }
}

/**
 * Check if a new version is available
 */
async function checkForUpdate() {
    const latestVersion = await getCurrentVersion();

    if (!latestVersion || !currentVersion) {
        return;
    }

    if (latestVersion !== currentVersion) {
        console.log('New version detected:', latestVersion, '(current:', currentVersion + ')');
        showUpdateNotification();
    }
}

/**
 * Show notification about new version and reload
 */
function showUpdateNotification() {
    // Create notification element
    const notification = document.createElement('div');
    notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 20px 24px;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    z-index: 10000;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    max-width: 400px;
    animation: slideIn 0.3s ease-out;
  `;

    notification.innerHTML = `
    <div style="display: flex; align-items: center; gap: 12px;">
      <svg style="width: 24px; height: 24px; flex-shrink: 0;" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clip-rule="evenodd"/>
      </svg>
      <div>
        <div style="font-weight: 600; margin-bottom: 4px;">New Version Available</div>
        <div style="font-size: 14px; opacity: 0.9;">Refreshing to get the latest updates...</div>
      </div>
    </div>
  `;

    // Add CSS animation
    const style = document.createElement('style');
    style.textContent = `
    @keyframes slideIn {
      from {
        transform: translateX(400px);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
  `;
    document.head.appendChild(style);
    document.body.appendChild(notification);

    // Reload after 2 seconds
    setTimeout(() => {
        window.location.reload(true);
    }, 2000);
}

/**
 * Stop version checking (cleanup)
 */
export function stopVersionCheck() {
    if (checkInterval) {
        clearInterval(checkInterval);
        checkInterval = null;
    }
}
